import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const PublicRoutes = () => {
  let authContext = useAuth();
  const location = useLocation();
  // console.log(authContext?.currentUser?.getIdTokenResult);

  return authContext?.currentUser && authContext.isMFAUser ? (
    // authContext.userRoles && authContext.userRoles.length > 0 ? (
    //   <Navigate to="/dashboard/home" />
    // ) : authContext.myInvites && authContext.myInvites.length > 0 ? (
    //   <Navigate to="/dashboard/invitelist" />
    // ) : (
    //   <Navigate to="/dashboard/" />
    // )
    <Navigate to="/dashboard/" />
  ) : (
    <Outlet context={authContext} />
  );
};

export default PublicRoutes;
